import {useContext} from "react";
import {dataVisualisationContext} from "../providers/dataVisualisationProvider";

export function useDataVisualisation() {
    return useContext(dataVisualisationContext);
}